module.exports = {
  getUserYear: function (userId, year) {
    return this.client.get(`/eoy/${year}/`, {
      params: {
        valid: 1,
        user_id: userId,
      },
    })
  },
}



// WEBPACK FOOTER //
// ./shared/mapmy/yearInReview.js